module.exports = __webpack_public_path__ + "2d67a7658ea57b241960806d9ec3dc69.svg";